import React from 'react';
import PropTypes from 'prop-types';

function ConnectedAccountsIcon({ className = 'h-4 w-4' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <circle cx='18' cy='18' r='3' />
      <circle cx='6' cy='6' r='3' />
      <path d='M13 6h3a2 2 0 0 1 2 2v7' />
      <path d='M11 18H8a2 2 0 0 1-2-2V9' />
    </svg>
  );
}

ConnectedAccountsIcon.propTypes = {
  className: PropTypes.string,
};

export default ConnectedAccountsIcon;
